import React from 'react';
import { RefreshCw, ExternalLink } from 'lucide-react';
import { formatDate } from '../utils/dateUtils';
import '../styles/CommentsTable.css';

const CommentsTable = ({ comments, loading, onRefresh, params }) => {
  // Build URL for the "View All Comments" page
  const buildAllCommentsUrl = () => {
    const baseUrl = window.location.origin + '/all-comments';
    const queryParams = new URLSearchParams({
      Retail_Assoc_Key: params?.retailAssoc || '',
      Period_Key: params?.period || '',
    });
    return `${baseUrl}?${queryParams.toString()}`;
  };

  const handleViewAllComments = () => {
    const url = buildAllCommentsUrl();
    window.open(url, '_blank', 'noopener,noreferrer');
  };

  return (
    <div className="comments-table-card">
      <div className="table-header">
        <div className="table-header-left">
          <h2>Existing Comments</h2>
          <button
            onClick={handleViewAllComments}
            className="view-all-button"
            title="View all comments for this Time Period and RA (opens in new tab)"
          >
            <ExternalLink size={14} />
            View All Comments
          </button>
        </div>
        <button
          onClick={onRefresh}
          disabled={loading}
          className="refresh-button"
        >
          <RefreshCw size={16} className={loading ? 'spinning' : ''} />
          Refresh
        </button>
      </div>
      
      <div className="table-wrapper">
        <table className="comments-table">
          <thead>
            <tr>
              <th>Date/Time</th>
              <th>UserName</th>
              <th>LineItem</th>
              <th>Comment</th>
            </tr>
          </thead>
          <tbody>
            {comments.length === 0 ? (
              <tr>
                <td colSpan="4" className="empty-state">
                  {loading ? 'Loading comments...' : 'No comments yet. Be the first to add one!'}
                </td>
              </tr>
            ) : (
              comments.map((comment, index) => (
                <tr key={index}>
                  <td className="date-cell">{formatDate(comment.created)}</td>
                  <td className="username-cell">{comment.user}</td>
                  <td className="lineitem-cell">{comment.lineItem}</td>
                  <td className="comment-cell">{comment.comment}</td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default CommentsTable;
